import { IndividualVerificationProvider } from "./individuals-enums";
import { IndividualVerificationStatus } from "./individual-verification-status";

export class IndividualVerificationModel{
  verificationId!: string;
  fullName!: string;
  email!: string;
  phone!: string;
  status!: IndividualVerificationStatus;
  provider: IndividualVerificationProvider | null;
  warningMessage: string | null = null;
  documentLink: string | null = null;
  created: Date = new Date();
  verified:   Date | null = null;
  unverified: Date | null = null;
  cancelled:  Date | null = null;

  constructor(init?: Partial<IndividualVerificationModel>) {
    this.verificationId = init?.verificationId ?? '';
    this.fullName = init?.fullName ?? '';
    this.email = init?.email ?? '';
    this.phone = init?.phone ?? '';
    this.status = init?.status ?? IndividualVerificationStatus.NotVerified;
    this.provider = init?.provider ?? null;
    this.warningMessage = init?.warningMessage ?? null;
    this.documentLink = init?.documentLink ?? null;
    this.created = init?.created ? new Date(init.created) : new Date();
    this.verified = init?.verified ? new Date(init.verified) : null;
    this.unverified = init?.unverified ? new Date(init.unverified) : null;
    this.cancelled = init?.cancelled ? new Date(init.cancelled) : null;
  }

}
